"use strict";

exports.TransactionHttpRepository = void 0;
var _constants = require("../data/constants");
var _VerificationFailedError = require("../data/errors/VerificationFailedError");
var _sdkTypes = require("../data/sdk-types");
var _HttpRepository = require("./HttpRepository");
class TransactionHttpRepository extends _HttpRepository.HttpRepository {
  constructor() {
    super(_constants.VerificationURI.US);
  }
  async getTransactionHistoryBySourceAsync(sourceAddress) {
    const res = await this.getAsync("verification/transactions/sourceAddress/".concat(sourceAddress));
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError('Failed to get transaction history by source address', {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_VERIFICATION_LAMBDA,
        description: 'Unexpected error while trying to get transaction history by source address'
      });
    }
    return res.content;
  }
  async getTransactionHistory() {
    const res = await this.getAsync('verification/transactions');
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError('Failed to get transaction history', {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_VERIFICATION_LAMBDA,
        description: 'Unexpected error while trying to get transaction history'
      });
    }
    return res.content;
  }
  async getTransactionHistoryByAffiliateAsync(affiliateAddress) {
    const res = await this.getAsync("verification/transactions/affiliateAddress/".concat(affiliateAddress));
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError('Failed to get transaction history by affiliate address', {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_VERIFICATION_LAMBDA,
        description: 'Unexpected error while trying to get transaction history by affiliate address'
      });
    }
    return res.content;
  }
  async getTransactionByIdAsync(transactionId) {
    const res = await this.getAsync("verification/transactions/transactionId/".concat(transactionId));
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError('Failed to get transaction by id', {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_VERIFICATION_LAMBDA,
        description: 'Unexpected error while trying to get transaction by id'
      });
    }
    return res.content;
  }
  async insertBaseTransaction(wrappedPayload) {
    const res = await this.postAsync('verification/transactions/baseTransaction', wrappedPayload);
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError('Failed to insert base transaction', {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_VERIFICATION_LAMBDA,
        description: 'Unexpected error while trying to insert base transaction'
      });
    }
    return res.content;
  }
  async updateTransactionStatus(transactionId, status) {
    const res = await this.putAsync("verification/transactions/transactionId/".concat(transactionId, "/status"), {
      status
    });
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError('Failed to update transaction status', {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_VERIFICATION_LAMBDA,
        description: 'Unexpected error while trying to update transaction status'
      });
    }
    return res.content;
  }
}
exports.TransactionHttpRepository = TransactionHttpRepository;